export { Modal } from './modal';
export { JSNativeModalContext, JSNativeModalContextBuilder } from './modal-context';
export { JSNativeModalRenderer } from './js-native-modal-renderer';
export { JSNativePresetBuilder } from './presets/js-native-preset';
export { JSNativeModalModule, providers } from './js-native.module';
//# sourceMappingURL=js-native.js.map


//////////////////
// WEBPACK FOOTER
// ./.tmp/angular2-modal/plugins/js-native/src/js-native.js
// module id = 6
// module chunks = 0